import { Eye, LogOut } from "lucide-react";
import { useAuth } from "../../store/AuthContext";

// Shown while the owner is inside a customer's account ("View as customer" from Admin → Customers).
export const ViewingAsBanner = () => {
  const { user, exitViewAs } = useAuth();
  if (!user?.viewing_as) return null;
  return (
    <div className="flex items-center gap-3 border-b border-[#f5a524]/50 bg-[#f5a524]/15 px-3 py-1.5 text-[12px] text-[#f5c542]" data-testid="viewing-as-banner">
      <Eye className="h-4 w-4 flex-shrink-0" />
      <span className="min-w-0 truncate">
        Viewing as <b className="text-[#ffe08a]">{user.name || user.shop_name || user.email}</b> <span className="text-[#f5c542]/80">({user.email})</span> — you see and change exactly what they see. They stay signed in; payments and profile are locked while viewing.
      </span>
      <button data-testid="exit-view-as-btn" onClick={exitViewAs} className="ml-auto flex flex-shrink-0 items-center gap-1 rounded-md border border-[#f5a524]/60 bg-[#f5a524]/20 px-2.5 py-1 font-semibold text-[#ffe08a] hover:bg-[#f5a524]/30">
        <LogOut className="h-3.5 w-3.5" /> Back to my account
      </button>
    </div>
  );
};
